import { render, staticRenderFns } from "./bo-datatable-row.vue?vue&type=template&id=6d2e78c4"
import script from "./bo-datatable-row.vue?vue&type=script&lang=js"
export * from "./bo-datatable-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports